/**
 * Currencies Constants
 * Comprehensive list of all supported currencies
 * Sourced from ev-flutter implementation
 */

import { CurrencyItem } from '../types/currencies-types';

export const ALL_CURRENCIES: CurrencyItem[] = [
  { id: 'USD', code: 'USD', symbol: '$', name: 'United States Dollar' },
  { id: 'EUR', code: 'EUR', symbol: '€', name: 'Euro' },
  { id: 'JPY', code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { id: 'GBP', code: 'GBP', symbol: '£', name: 'British Pound' },
  { id: 'AUD', code: 'AUD', symbol: '$', name: 'Australian Dollar' },
  { id: 'CAD', code: 'CAD', symbol: '$', name: 'Canadian Dollar' },
  { id: 'CHF', code: 'CHF', symbol: 'CHF', name: 'Switzerland Franc' },
  { id: 'CNY', code: 'CNY', symbol: '¥', name: 'China Yuan Renminbi' },
  { id: 'HKD', code: 'HKD', symbol: '$', name: 'Hong Kong Dollar' },
  { id: 'NZD', code: 'NZD', symbol: '$', name: 'New Zealand Dollar' },
  { id: 'SEK', code: 'SEK', symbol: 'kr', name: 'Sweden Krona' },
  { id: 'KRW', code: 'KRW', symbol: '₩', name: 'South Korea Won' },
  { id: 'SGD', code: 'SGD', symbol: '$', name: 'Singapore Dollar' },
  { id: 'NOK', code: 'NOK', symbol: 'kr', name: 'Norway Krone' },
  { id: 'MXN', code: 'MXN', symbol: '$', name: 'Mexico Peso' },
  { id: 'INR', code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { id: 'RUB', code: 'RUB', symbol: '₽', name: 'Russia Ruble' },
  { id: 'ZAR', code: 'ZAR', symbol: 'R', name: 'South Africa Rand' },
  { id: 'TRY', code: 'TRY', symbol: '₺', name: 'Turkish Lira' },
  { id: 'BRL', code: 'BRL', symbol: 'R$', name: 'Brazilian Real' },
  { id: 'TWD', code: 'TWD', symbol: 'NT$', name: 'Taiwan New Dollar' },
  { id: 'DKK', code: 'DKK', symbol: 'kr', name: 'Denmark Krone' },
  { id: 'PLN', code: 'PLN', symbol: 'zł', name: 'Poland Zloty' },
  { id: 'THB', code: 'THB', symbol: '฿', name: 'Thailand Baht' },
  { id: 'IDR', code: 'IDR', symbol: 'Rp', name: 'Indonesia Rupiah' },
  { id: 'HUF', code: 'HUF', symbol: 'Ft', name: 'Hungary Forint' },
  { id: 'CZK', code: 'CZK', symbol: 'Kč', name: 'Czech Koruna' },
  { id: 'ILS', code: 'ILS', symbol: '₪', name: 'Israel Shekel' },
  { id: 'CLP', code: 'CLP', symbol: '$', name: 'Chile Peso' },
  { id: 'PHP', code: 'PHP', symbol: '₱', name: 'Philippines Peso' },
  { id: 'AED', code: 'AED', symbol: 'د.إ', name: 'Emirati Dirham' },
  { id: 'COP', code: 'COP', symbol: '$', name: 'Colombia Peso' },
  { id: 'SAR', code: 'SAR', symbol: '﷼', name: 'Saudi Arabia Riyal' },
  { id: 'MYR', code: 'MYR', symbol: 'RM', name: 'Malaysia Ringgit' },
  { id: 'RON', code: 'RON', symbol: 'L', name: 'Romania Leu' },
  { id: 'AFN', code: 'AFN', symbol: '؋', name: 'Afghanistan Afghani' },
  { id: 'ARS', code: 'ARS', symbol: '$', name: 'Argentine Peso' },
  { id: 'BBD', code: 'BBD', symbol: '$', name: 'Barbados Dollar' },
  { id: 'BDT', code: 'BDT', symbol: 'Tk', name: 'Bangladeshi Taka' },
  { id: 'BGN', code: 'BGN', symbol: 'лв', name: 'Bulgarian Lev' },
  { id: 'BHD', code: 'BHD', symbol: 'BD', name: 'Bahraini Dinar' },
  { id: 'BMD', code: 'BMD', symbol: '$', name: 'Bermuda Dollar' },
  { id: 'BND', code: 'BND', symbol: '$', name: 'Brunei Darussalam Dollar' },
  { id: 'BOB', code: 'BOB', symbol: '$b', name: 'Bolivia Bolíviano' },
  { id: 'BTN', code: 'BTN', symbol: 'Nu.', name: 'Bhutanese Ngultrum' },
  { id: 'BZD', code: 'BZD', symbol: 'BZ$', name: 'Belize Dollar' },
  { id: 'CRC', code: 'CRC', symbol: '₡', name: 'Costa Rica Colon' },
  { id: 'DOP', code: 'DOP', symbol: 'RD$', name: 'Dominican Republic Peso' },
  { id: 'EGP', code: 'EGP', symbol: '£', name: 'Egypt Pound' },
  { id: 'ETB', code: 'ETB', symbol: 'Br', name: 'Ethiopian Birr' },
  { id: 'GEL', code: 'GEL', symbol: '₾', name: 'Georgian Lari' },
  { id: 'GHS', code: 'GHS', symbol: '₵', name: 'Ghana Cedi' },
  { id: 'GMD', code: 'GMD', symbol: 'D', name: 'Gambian dalasi' },
  { id: 'GYD', code: 'GYD', symbol: '$', name: 'Guyana Dollar' },
  { id: 'HRK', code: 'HRK', symbol: 'kn', name: 'Croatia Kuna' },
  { id: 'ISK', code: 'ISK', symbol: 'kr', name: 'Iceland Krona' },
  { id: 'JMD', code: 'JMD', symbol: 'J$', name: 'Jamaica Dollar' },
  { id: 'KES', code: 'KES', symbol: 'KSh', name: 'Kenyan Shilling' },
  { id: 'KWD', code: 'KWD', symbol: 'د.ك', name: 'Kuwaiti Dinar' },
  { id: 'KYD', code: 'KYD', symbol: '$', name: 'Cayman Islands Dollar' },
  { id: 'KZT', code: 'KZT', symbol: '〒', name: 'Kazakhstan Tenge' },
  { id: 'LAK', code: 'LAK', symbol: '₭', name: 'Laos Kip' },
  { id: 'LKR', code: 'LKR', symbol: '₨', name: 'Sri Lanka Rupee' },
  { id: 'LRD', code: 'LRD', symbol: '$', name: 'Liberia Dollar' },
  { id: 'MAD', code: 'MAD', symbol: 'MAD', name: 'Moroccan Dirham' },
  { id: 'MDL', code: 'MDL', symbol: 'L', name: 'Moldovan Leu' },
  { id: 'MKD', code: 'MKD', symbol: 'ден', name: 'Macedonia Denar' },
  { id: 'MNT', code: 'MNT', symbol: '₮', name: 'Mongolia Tughrik' },
  { id: 'MUR', code: 'MUR', symbol: '₨', name: 'Mauritius Rupee' },
  { id: 'MWK', code: 'MWK', symbol: 'MK', name: 'Malawian Kwacha' },
  { id: 'MZN', code: 'MZN', symbol: 'MT', name: 'Mozambique Metical' },
  { id: 'NAD', code: 'NAD', symbol: '$', name: 'Namibia Dollar' },
  { id: 'NGN', code: 'NGN', symbol: '₦', name: 'Nigeria Naira' },
  { id: 'NIO', code: 'NIO', symbol: 'C$', name: 'Nicaragua Cordoba' },
  { id: 'NPR', code: 'NPR', symbol: '₨', name: 'Nepal Rupee' },
  { id: 'OMR', code: 'OMR', symbol: '﷼', name: 'Oman Rial' },
  { id: 'PEN', code: 'PEN', symbol: 'S/.', name: 'Peru Sol' },
  { id: 'PGK', code: 'PGK', symbol: 'K', name: 'Papua New Guinean Kina' },
  { id: 'PKR', code: 'PKR', symbol: '₨', name: 'Pakistan Rupee' },
  { id: 'PYG', code: 'PYG', symbol: '₲', name: 'Paraguay Guarani' },
  { id: 'QAR', code: 'QAR', symbol: '﷼', name: 'Qatar Riyal' },
  { id: 'RSD', code: 'RSD', symbol: 'Дин.', name: 'Serbia Dinar' },
  { id: 'SOS', code: 'SOS', symbol: 'S', name: 'Somalia Shilling' },
  { id: 'SRD', code: 'SRD', symbol: '$', name: 'Suriname Dollar' },
  { id: 'TTD', code: 'TTD', symbol: 'TT$', name: 'Trinidad and Tobago Dollar' },
  { id: 'TZS', code: 'TZS', symbol: 'TSh', name: 'Tanzanian Shilling' },
  { id: 'UAH', code: 'UAH', symbol: '₴', name: 'Ukraine Hryvnia' },
  { id: 'UGX', code: 'UGX', symbol: 'USh', name: 'Ugandan Shilling' },
  { id: 'UYU', code: 'UYU', symbol: '$U', name: 'Uruguay Peso' },
  { id: 'VEF', code: 'VEF', symbol: 'Bs', name: 'Venezuela Bolívar' },
  { id: 'VND', code: 'VND', symbol: '₫', name: 'Viet Nam Dong' },
  { id: 'YER', code: 'YER', symbol: '﷼', name: 'Yemen Rial' },
  { id: 'ALL', code: 'ALL', symbol: 'Lek', name: 'Albanian Lek' },
  { id: 'AMD', code: 'AMD', symbol: '֏', name: 'Armenian Dram' },
  { id: 'AZN', code: 'AZN', symbol: '₼', name: 'Azerbaijani Manat' },
  { id: 'BIF', code: 'BIF', symbol: 'FBu', name: 'Burundian Franc' },
  { id: 'BWP', code: 'BWP', symbol: 'P', name: 'Botswanan Pula' },
  { id: 'BYN', code: 'BYN', symbol: 'Br', name: 'Belarussian Ruble' },
  { id: 'SYP', code: 'SYP', symbol: 'LS', name: 'Syrian Lira' },
  { id: 'SCR', code: 'SCR', symbol: '₨', name: 'Seychellois rupee' },
  { id: 'BAM', code: 'BAM', symbol: 'KM', name: 'Bosnia and Herzegovina convertible mark' },
];

/**
 * Get currency by code
 */
export function getCurrencyByCode(code: string): CurrencyItem | undefined {
  return ALL_CURRENCIES.find(c => c.code === code);
}

/**
 * Get all currency codes
 */
export function getCurrencyCodes(): string[] {
  return ALL_CURRENCIES.map(c => c.code).sort();
}
